<template>
    <!-- 各门店票核销统计－页面 -->
    <div>
        <content-view class="ticket-count" v-show="$utils.renderWhen(this,'ticketSettle')">
            <div class="wrap-container-in">
                <section class="flex flex-align-start flex-space-between">
                    <a-spin :spinning="schemeSpinning">
                        <div class="ticket-scheme-raido-container">
                            <div v-for="item in allSchemesList" :key="item.id">
                                <a-radio @click="onClickRideo(item.id)" :checked="item.checked" >{{item.schemeName}}</a-radio> <a-divider v-if="item.id && item.id > 0" type="vertical" /> 
                                <a-popconfirm title="确定要删除该方案吗？" @confirm="delScheme(item.id)" okText="确定" cancelText="取消">
                                    <a-icon v-if="canDetele && item.id && item.id > 0" type="close-circle" style="color:#f31d2b" />
                                </a-popconfirm>
                                <a-icon v-if="!canDetele" type="edit" @click="getTicketList(item.id)" />
                            </div>
                        </div>
                        <div class="text-center" v-if="allSchemesList.length === 0">暂无方案，请先进行方案新增</div>
                    </a-spin>
                    <div style="width: 240px" class="flex flex-end">
                        <a-button type="primary" @click="showAddSchemeModal">新增</a-button>
                        <a-button v-if="!canDetele" @click="deleteSellPlan">删除</a-button>
                        <a-button v-if="canDetele" type="primary" @click="cancelDelete">完成</a-button>
                    </div>
                </section>
                <a-divider></a-divider>
                <a-table :loading="loading" :bordered="true" :scroll="{ x: columns.length*90}" :pagination="false" @change="changePage"
                :dataSource="dataSource" :rowKey="(record,index) => index"
                :rowClassName="(record, index) => {
                    let className = 'light-row';
                    if (index % 2 === 1) className = 'dark-row';
                    return className;
                }"
                >
                    <template v-for="(items, index) in columns">
                        <a-table-column v-if="index>0" :key="index" :data-index="index">
                            <span slot="title">{{items.shopName}}</span>
                            <template slot-scope="item, a, b">
                                <span :style="a.return == 1 || Number(item) <= 0?'':'color: #1890ff; cursor: pointer;'" @click="toTicketDetail(a, index, item)">
                                    {{item | priceFormat}}
                                </span>
                            </template>
                        </a-table-column>
                        <a-table-column v-else :key="index" :data-index="0">
                            <section :data-index='0' slot="title" class="ticket-count-tablebox flex flex-column">
                                <span>门店名称</span>
                                <p></p>
                                <span>余额占比金额统计</span>
                                <p></p>
                                <span>票券名称</span>
                            </section>
                        </a-table-column>
                    </template>
                </a-table>
                <div class="text-center" v-if="columns.length === 0">暂无数据，请先浏览其他页面～</div>
            </div>
            <!-- 新增方案弹窗 -->
            <a-modal 
            :title="schemetitle"
            :confirmLoading="addSchemeLoading"
            :visible="addSchemeVisible"
            :bodyStyle="{padding: 0}"
            @cancel="hideAddSchemeModal"
            @ok="addScheme"
            :width="900"
            >   
                <a-spin :spinning="ticketListSpinning">
                    <a-form :form="addSchemeForm" :selfUpdate="true">
                        <div class="mt16"></div>
                        <a-form-item label="方案名称" :labelCol="{span: 3}" :wrapperCol="{span: 8}">
                            <a-input v-decorator="['name',{rules: [{required: true, message: '请输入'},{max: 15, message: '最多15个字符'}]}]" placeholder="请输入" />
                        </a-form-item>
                        <a-form-item v-if="ticketList.onlineTickets.length" label="线上票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                            <div class="select-ticket-container">
                                <a-checkbox-group :options="ticketList.onlineTickets" v-decorator="['onlineIds[0]',{initialValue: []}]" />
                            </div>
                        </a-form-item>
                        <a-form-item label="线下票券" :labelCol="{span: 3}" :wrapperCol="{span: 20}">
                            <div class="select-ticket-container" v-if="shopId != -1">
                                <a-checkbox-group :options="ticketList.offlineTickets" v-decorator="['offlineIds[0]',{initialValue: []}]" />
                            </div>
                            <div class="select-ticket-container" v-if="shopId == -1">
                                <template v-for="(item, index) in ticketList.shopExpTicketList">
                                    <section :key="index">
                                        <span>{{item.shopName}}</span>
                                        <a-checkbox-group :options="item.ticketVoList" v-decorator="['offlineIds[0]',{initialValue: []}]" />
                                    </section>
                                </template>
                            </div>
                        </a-form-item>
                    </a-form>
                </a-spin>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
    name: "ticketSettle",
    components: {},
    props: {},
    data() {
        return {
            columns: [],
            dataSource: [],
            tabListNoTitle: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            loading: false,
            key: undefined,
            name: '',
            addSchemeVisible: false,
            ticketList:  {
                offlineTickets: [],
                onlineTickets: [],
            },
            exportLoading: false,
            schemeSpinning: false,
            ticketListSpinning: false,
            addSchemeLoading: false,
            schemeId: undefined,
            activeSchemeId: undefined,
            allSchemesList: [],
            canDetele: false,
            isSchemeEdit: false,
            schemetitle: "", 
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    filters: {
        ticketIndex(index, ticketIndex, columns) {
            var length = 0;
            for (let i = 0; i < ticketIndex; i++) {
                length += columns[i].ticket.length;
                
            }
            return length + index;
        },
        priceFormat(val) {
            return val.toFixed(2);
        }
    },
    methods: {
        toTicketDetail(item, index, num) {
            if (index == 0 || item.return == 1 || Number(num) == 0) {
                return;
            };
            this.form.validateFields((err, values) => {
                this.$router.push({name: "ticketSettleDetail", query: { id: item.ticketId, shopId: this.columns[index].shopId, lineType: item.lineType}})
            })
        },
        /**
         * @showAddSchemeModal 显示新增方案弹窗
         */
        showAddSchemeModal() {
            this.schemetitle = "新增方案";
            this.addSchemeVisible = true;
            this.isSchemeEdit = false;
        },
        /**
         * @hideAddSchemeModal 隐藏新增方案弹窗
         */
        hideAddSchemeModal() {
            this.addSchemeForm.setFieldsValue({
                name: undefined,
                onlineIds: [[], []],
                offlineIds: [[], []]
            });
            this.addSchemeVisible = false;
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getData()
        },
        getShopList(bool) {
            if(!this.shopId) return
            this.$api.totalPlatform.selectList()
            .then(res => {
                this.tabListNoTitle = []
                if(this.shopId == -1) {
                    res.map(item => {
                        this.tabListNoTitle.push({
                            key: item.id,
                            tab: item.name
                        })
                    })
                }else {
                    this.tabListNoTitle.push({
                        key: this.shopId,
                        tab: res.filter(item => item.id == this.shopId)[0].name
                    })
                }
                
                this.key = String(this.tabListNoTitle[0].key);
                this.name = String(this.tabListNoTitle[0].tab);
                this.getTicketList();
                if (!bool) {
                    this.queryAllSchemes();
                }
            });
        },
        /**
         * @getTicketList 门店线上线下票
         */
        getTicketList(schemeId) {
            this.ticketListSpinning = true;
            if (schemeId) {
                this.addSchemeVisible = true;
                this.isSchemeEdit = true;
                this.schemetitle = "编辑方案";
            }
            this.$api.statement.getExprTickets({
                params: {
                    shopId: this.shopId
                }
            }).then(res => {
                if (this.shopId == -1) {
                    res.onlineTickets.forEach(item => {
                        item.label = item.name;
                        item.value = item.ticketId;
                    });
                    res.shopExpTicketList.forEach(item => {
                        item.ticketVoList.forEach( el => {
                            el.label = el.name;
                            el.value = el.ticketId;
                        })
                    });
                } else {
                    res.offlineTickets.forEach(item => {
                        item.label = item.name;
                        item.value = item.ticketId;
                    });
                }
                
                
                this.ticketList = res;
                this.ticketListSpinning = false;
                if (schemeId) {
                    this.getSchemeInfo(schemeId);
                }
            });
        },
        /**
         * @queryAllSchemes 查询方案
         */
        queryAllSchemes() {
            this.schemeSpinning = true;
            this.$api.statement.getExprScheme({
                params: {
                    shopId: this.shopId
                }
            }).then(res => {
                if (!res.length) {
                    this.schemeSpinning = false;
                    this.schemeId = undefined;
                    this.allSchemesList = [];
                } else {
                    res.forEach(item => {
                        item.checked = false;
                    })
                    res[0].checked = true;
                    this.schemeId = res[0].id;
                }
                this.schemeSpinning = false;
                this.allSchemesList = res;
                this.getData();
            });
        },
        /**
         * @getDate 获取报表数据
         */
        getData() {
            if (!this.schemeId) {
                this.loading = false
                this.dataSource = [];
                this.columns = [];
                return;
            }
            this.form.validateFields((errors,values) => {
                if (errors) return;
                this.loading = true
                this.$api.statement.queryBalanceSettlement({body:{
                    shopId: this.shopId * 1,
                    schemeId: this.schemeId,
                }}).then((res) => {
                    this.loading = false
                    this.dataSource = []
                    if (!res.data.length) {
                        return;
                    };
                    this.columns = [{
                        shopName: "",
                    }]
                    var ticketIndex = 1;
                    let total = {0: "合计", return: 1};
                    this.columns = [...this.columns, ...res.shopList]
                    res.data.forEach( (item, indexs) => {
                        this.dataSource[indexs] = {
                            lineType: item.lineType,
                            ticketId: item.ticketId,
                            0: item.ticketName
                        }
                        item.totalList.forEach( (el, index) => {
                            this.dataSource[indexs][index + 1] = el;
                        })
                    });
                    res.amountList.forEach((el, index) => {
                        total[index + 1] = el;
                    });
                    this.dataSource.push(total);
                }).catch(err => {
                    this.loading = false
                
                })
            });
        },
        // 导出excel
        exportExcel() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                this.exportLoading = true;
                this.$api.statement
                .exportExcel({
                    body: {   
                        pageNum: 1,
                        pageSize: 99999999,
                        shopId: this.shopId,
                        schemeId: this.schemeId,
                        startDate: values.startDate.format('YYYY-MM-DD'),
                        endDate: values.endDate.format('YYYY-MM-DD')
                    }
                },
                {
                    responseType: "blob"
                })
                .then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    let name = this.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();
                    this.exportLoading = false

                });
            })
        },
        /**
         * @addScheme 新增/编辑方案
         */
        addScheme(){
            this.addSchemeForm.validateFields((errors, values) => {
                if(errors) {
                    return false;
                }
                if (this.shopId != -1) {
                    values.onlineIds = [];
                };
                if (!values.onlineIds.flat().length && !values.offlineIds.flat().length) {
                    this.$message.error('票券不能为空');
                    return false;
                }
                this.addSchemeLoading = true;
                let reqData = {
                    shopId: this.shopId,
                    schemeName: values.name,
                    onlineIds: values.onlineIds.flat(),
                    offlineIds: values.offlineIds.flat(),
                };
                if (this.isSchemeEdit) {
                    reqData.schemeId = this.activeSchemeId;
                }
                this.$api.statement.exprScheme(
                    {
                        body: reqData
                    }
                ).then(res => {
                    this.addSchemeLoading = false;
                    this.$message.success('操作成功！');
                    this.hideAddSchemeModal();
                    this.queryAllSchemes();
                }).catch(error => {
                    this.addSchemeLoading = false;
                });
            });
        },
        /**
         * @delScheme 删除方案
         */
        delScheme(schemeId){
            this.$api.statement.delExprScheme({
                params: {
                    schemeId
                }
            }).then(res => {
                this.$message.success('删除成功！');
                this.queryAllSchemes();
            });
        },
        /**
         * @getSchemeInfo 获取方案详情
         */
        getSchemeInfo(schemeId) {
            // if (!this.ticketList.onlineTickets.length || !this.ticketList.offlineTickets.length) return;
            this.activeSchemeId = schemeId;
            let selectedScheme = this.allSchemesList.find( el => {
                return el.id == schemeId;
            });
            /**
             * @offlineIdsArray 详情结果票券id数组
             * @onlineIdsArray 详情结果票券id数组
             * @sOnlineTickets 正在售卖的线上票列表
             * @sOfflineTickets 正在售卖的线下票列表
             * @wOnlineTickets 已下架/删除的线上票列表
             * @wOfflineTickets 已下架/删除的线下票列表
             * @sOnlineIds 方案详情正在售卖的线上票券id
             * @sOfflineIds 方案详情正在售卖的线下票券id
             * @wOnlineIds 方案详情已下架/删除的线上票券id
             * @wOfflineIds 方案详情已下架/删除的线下票券id
             */
            let onlineIdsArray = selectedScheme.onlineId.split(',');
            let offlineIdsArray = selectedScheme.offlineId.split(',');
            let sOnlineTickets = this.ticketList.onlineTickets;
            let sOfflineTickets = this.ticketList.offlineTickets;
            let sOnlineIds = [];
            let sOfflineIds = [];
            // 线上在售票券筛选
            sOnlineTickets.forEach(items => {
                let findRes = onlineIdsArray.find(item => Number(item) == items.ticketId);
                if (typeof findRes !== 'undefined') {
                    sOnlineIds.push(Number(findRes));
                }
            });
            // 线下在售票券筛选
            sOfflineTickets.forEach(items => {
                let findRes = offlineIdsArray.find(item => Number(item) == items.ticketId);
                if (typeof findRes !== 'undefined') {
                    sOfflineIds.push(Number(findRes));
                }
            });
            setTimeout(() => {
                this.ticketListSpinning = false;
                this.addSchemeForm.setFieldsValue({
                    name: selectedScheme.schemeName,
                    onlineIds: [sOnlineIds],
                    offlineIds: [sOfflineIds]
                });
            }, 300);
            
        },
        /**
         * @deleteSellPlan 删除按钮
         */
        deleteSellPlan() {
            this.canDetele = true;
        },
        /**
         * @cancelDelete 删除完成按钮
         */
        cancelDelete() {
            this.canDetele = false;
            this.queryAllSchemes();
        },
        /**
         * @onClickRideo 方案radio的点击事件
         */
        onClickRideo(id) {
            this.schemeId = id
            this.getData();
            this.allSchemesList.forEach(item => {
                item.checked = false
                if(item.id === id) {
                    item.checked = true
                }
            })
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.addSchemeForm = this.$form.createForm(this);
    },
    created() {
    },
    mounted() {
        this.getShopList();
    },
    watch: {
        'shopId'() {
            if (this.$route.name == "ticketSettle") {
            this.getShopList();
            }
        },
        "$route.name"(val) {
            if (val == "ticketSettle") {
                this.getShopList(true);
            }
        }
    }
};
</script>
<style lang="scss">
.ticket-count {
    &-tablebox {
        min-width: 150px;
        position: relative;
        background: linear-gradient(
            to top right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - .5px),
            rgba(0, 0, 0, 0.5) 50%,
            rgba(0, 0, 0, 0) calc(50% + .5px),
            rgba(0, 0, 0, 0) 100%
        );
        // p:empty {
        //     width: 100%;
        //     height: 1px;
        //     background: #EEE;
        //     transform: rotate(20deg);
        // }
        span {
            font-size: 12px;
            display: inline-block;
            width: 100%;
            height: 50%;
            &:first-child {
                text-align: right;
            }
            &:last-child {
                text-align: left;
            }
        }
    }
    .wrap-title {
        padding-bottom: 8px;
    }
    .wrap-header {
        padding-bottom: 0;
    }
    .wrap-container-in {
        padding: 16px;
    }
    .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
        padding: 6px;
    }
    .dark-row {
        background-color: #f9f9f9;
    }
    table td,
    table th {
        text-align: center;
    }
    .ant-table-column-sorter {
        display: none;
    }
    .ticket-scheme-raido-container {
        >div {
            display: inline-block;
            margin: 0 8px 8px 0;
            padding: 4px 12px;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            &:hover {
                border: 1px solid #ff9646;
            }
        }
    }
}
.select-ticket-container {
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: scroll;
}
</style>